import React from "react";
import * as S from "./styles";
import { withRouter, useHistory } from "react-router-dom";
import Loader from "../../assets/img/bookingfinishloader.gif";
import { Typography } from "@material-ui/core";
import ThemeButton from "../../components/ThemeButton";
import {
	BOOKING_PROCESSING_GROUPS,
	getBookingProcessingMessage,
} from "../../utils/bookingProcessingMessages";

/**
 * Demanda 240 — a tela passa a variar conforme o grupo de status do fornecedor
 * (seção 5), em vez de exibir um texto único.
 *
 * O grupo chega por prop ou pelo sessionStorage (`@booking-processing-group`),
 * gravado por quem redirecionou para cá. Sem grupo, cai no texto de
 * "Em andamento" — o mais neutro, que não promete prazo nem anuncia falha.
 */
function BookingProcessing({ group }) {
	const history = useHistory();

	const grupo = group || lerGrupoDaSessao();
	const { titulo, texto, emFalha } = getBookingProcessingMessage(grupo);

	return (
		<S.Wrapper>
			{/* Em falha definitiva o loader mentiria: não há mais nada em andamento. */}
			{!emFalha && <img src={Loader} alt="Reserva em processamento" />}
			<Typography variant="h3">{titulo}</Typography>
			<Typography variant="span">{texto}</Typography>
			<ThemeButton
				onClick={() => history.push("/conta/minhas-viagens")}
				className="pesquisa"
			>
				Ver minhas viagens
			</ThemeButton>
		</S.Wrapper>
	);
}

const lerGrupoDaSessao = () => {
	try {
		return sessionStorage.getItem("@booking-processing-group") || BOOKING_PROCESSING_GROUPS.EM_ANDAMENTO;
	} catch (e) {
		// sessionStorage pode estar bloqueado (janela anônima, cookies desativados).
		return BOOKING_PROCESSING_GROUPS.EM_ANDAMENTO;
	}
};

export default withRouter(BookingProcessing);
